import Vue from 'vue'

export const BLOG_SET_POSTS = 'BLOG_SET_POSTS'
export const BLOG_SET_PHOTOS = 'BLOG_SET_PHOTOS'
export const BLOG_SET_VIDEOS = 'BLOG_SET_VIDEOS'
export const BLOG_SET_CATALOGS = 'BLOG_SET_CATALOGS'
export const BLOG_SET_FILES = 'BLOG_SET_FILES'
export const BLOG_SET_POST = 'BLOG_SET_POST'
export const BLOG_SET_VIDEO = 'BLOG_SET_VIDEO'
export const BLOG_SET_CATALOG = 'BLOG_SET_CATALOG'
export const BLOG_SET_FILE = 'BLOG_SET_FILE'
export const BLOG_SET_ABOUT_PRIEST = 'BLOG_SET_ABOUT_PRIEST'
export const BLOG_ADD_COMMENT_POST = 'BLOG_ADD_COMMENT_POST'
export const BLOG_ADD_COMMENT_PHOTO = 'BLOG_ADD_COMMENT_PHOTO'
export const BLOG_ADD_COMMENT_VIDEO = 'BLOG_ADD_COMMENT_VIDEO'
export const BLOG_SET_COMMENT_POST = 'BLOG_SET_COMMENT_POST'
export const BLOG_SET_COMMENT_PHOTO = 'BLOG_SET_COMMENT_PHOTO'
export const BLOG_SET_COMMENT_VIDEO = 'BLOG_SET_COMMENT_VIDEO'
export const BLOG_VOTE_POST = 'BLOG_VOTE_POST'
export const BLOG_VOTE_PHOTO = 'BLOG_VOTE_PHOTO'
export const BLOG_VOTE_VIDEO = 'BLOG_VOTE_VIDEO'
export const BLOG_LIB_CATALOG_OPEN = 'BLOG_LIB_CATALOG_OPEN'
export const BLOG_LIB_CATALOG_CLOSE = 'BLOG_LIB_CATALOG_CLOSE'
export const BLOG_DELETE_PHOTO = 'BLOG_DELETE_PHOTO'
export const BLOG_DELETE_VIDEO = 'BLOG_DELETE_VIDEO'

export default {
  [BLOG_SET_ABOUT_PRIEST] (state, { parish, info }) {
    Vue.set(state.about, parish.id, info)
  },
  [BLOG_SET_POSTS] (state, { parish, posts }) {
    if (!state.posts[parish.id]) {
      Vue.set(state.posts, parish.id, {})
    }
    Object.keys(posts).forEach(id => {
      Vue.set(state.posts[parish.id], id, posts[id])
    })
  },
  [BLOG_DELETE_PHOTO] (state, { parish, photo }) {
    Vue.delete(state.photos[parish.id], photo.id)
  },
  [BLOG_DELETE_VIDEO] (state, { parish, video }) {
    Vue.delete(state.videos[parish.id], video.id)
  },
  [BLOG_SET_PHOTOS] (state, { parish, photos }) {
    if (!state.photos[parish.id]) {
      Vue.set(state.photos, parish.id, {})
    }
    Object.keys(photos).forEach(id => {
      Vue.set(state.photos[parish.id], id, photos[id])
    })
  },
  [BLOG_SET_VIDEOS] (state, { parish, videos }) {
    if (!state.videos[parish.id]) {
      Vue.set(state.videos, parish.id, {})
    }
    Object.keys(videos).forEach(id => {
      Vue.set(state.videos[parish.id], id, videos[id])
    })
  },
  [BLOG_SET_POST] (state, { parish, post }) {
    if (!state.posts[parish.id]) {
      Vue.set(state.posts, parish.id, {})
    }
    Vue.set(state.posts[parish.id], post.id, post)
  },
  [BLOG_SET_VIDEO] (state, { parish, video }) {
    if (!state.videos[parish.id]) {
      Vue.set(state.videos, parish.id, {})
    }
    Vue.set(state.videos[parish.id], video.id, video)
  },
  [BLOG_SET_CATALOGS] (state, { parish, catalogs }) {
    Vue.set(state.catalogs, parish.id, {})
    Object.keys(catalogs).forEach(id => {
      Vue.set(state.catalogs[parish.id], id, catalogs[id])
    })
  },
  [BLOG_SET_CATALOG] (state, { parish, catalog }) {
    if (!state.catalogs[parish.id]) {
      Vue.set(state.catalogs, parish.id, {})
    }
    Vue.set(state.catalogs[parish.id], catalog.id, catalog)
  },
  [BLOG_SET_FILES] (state, { parish, files }) {
    Vue.set(state.files, parish.id, {})
    Object.keys(files).forEach(id => {
      Vue.set(state.files[parish.id], id, files[id])
    })
  },
  [BLOG_SET_FILE] (state, { parish, file }) {
    if (!state.files[parish.id]) {
      Vue.set(state.files, parish.id, {})
    }
    Vue.set(state.files[parish.id], file.id, file)
  },
  [BLOG_ADD_COMMENT_POST] (state, { parish, post, comment }) {
    state.posts[parish.id][post.id].comments.push(comment)
    if (comment.parent) {
      const index = state.posts[parish.id][post.id].comments.findIndex(c => c.id === comment.parent.id)
      Vue.set(state.posts[parish.id][post.id].comments[index], 'empty', false)
    }
  },
  [BLOG_ADD_COMMENT_PHOTO] (state, { parish, photo, comment }) {
    state.photos[parish.id][photo.id].comments.push(comment)
    if (comment.parent) {
      const index = state.photos[parish.id][photo.id].comments.findIndex(c => c.id === comment.parent.id)
      Vue.set(state.photos[parish.id][photo.id].comments[index], 'empty', false)
    }
  },
  [BLOG_ADD_COMMENT_VIDEO] (state, { parish, video, comment }) {
    state.videos[parish.id][video.id].comments.push(comment)
    if (comment.parent) {
      const index = state.videos[parish.id][video.id].comments.findIndex(c => c.id === comment.parent.id)
      Vue.set(state.videos[parish.id][video.id].comments[index], 'empty', false)
    }
  },
  [BLOG_SET_COMMENT_POST] (state, { parish, post, comment }) {
    const index = state.posts[parish.id][post.id].comments.findIndex(c => c.id === comment.id)
    Vue.set(state.posts[parish.id][post.id].comments, index, comment)
    if (comment.deleted && comment.parent) {
      let empty = state.posts[parish.id][post.id].comments.filter(c => c.parent && c.parent.id === comment.parent.id).reduce((empty, child) => child.deleted || empty, false)
      if (empty) {
        const index = state.posts[parish.id][post.id].comments.findIndex(c => c.id === comment.parent.id)
        Vue.set(state.posts[parish.id][post.id].comments[index], 'empty', true)
      }
    }
  },
  [BLOG_SET_COMMENT_PHOTO] (state, { parish, photo, comment }) {
    const index = state.photos[parish.id][photo.id].comments.findIndex(c => c.id === comment.id)
    Vue.set(state.photos[parish.id][photo.id].comments, index, comment)
    if (comment.deleted && comment.parent) {
      let empty = state.photos[parish.id][photo.id].comments.filter(c => c.parent && c.parent.id === comment.parent.id).reduce((empty, child) => child.deleted || empty, false)
      if (empty) {
        const index = state.photos[parish.id][photo.id].comments.findIndex(c => c.id === comment.parent.id)
        Vue.set(state.photos[parish.id][photo.id].comments[index], 'empty', true)
      }
    }
  },
  [BLOG_SET_COMMENT_VIDEO] (state, { parish, video, comment }) {
    const index = state.videos[parish.id][video.id].comments.findIndex(c => c.id === comment.id)
    Vue.set(state.videos[parish.id][video.id].comments, index, comment)
    if (comment.deleted && comment.parent) {
      let empty = state.videos[parish.id][video.id].comments.filter(c => c.parent && c.parent.id === comment.parent.id).reduce((empty, child) => child.deleted || empty, false)
      if (empty) {
        const index = state.videos[parish.id][video.id].comments.findIndex(c => c.id === comment.parent.id)
        Vue.set(state.videos[parish.id][video.id].comments[index], 'empty', true)
      }
    }
  },
  [BLOG_VOTE_POST] (state, { parish, post, vote }) {
    if (vote && vote.deleted) {
      state.posts[parish.id][post.id].votes.count--
      state.posts[parish.id][post.id].votes.self = false
    } else {
      state.posts[parish.id][post.id].votes.count++
      state.posts[parish.id][post.id].votes.self = true
    }
  },
  [BLOG_VOTE_PHOTO] (state, { parish, photo, vote }) {
    if (vote && vote.deleted) {
      state.photos[parish.id][photo.id].votes.count--
      state.photos[parish.id][photo.id].votes.self = false
    } else {
      state.photos[parish.id][photo.id].votes.count++
      state.photos[parish.id][photo.id].votes.self = true
    }
  },
  [BLOG_VOTE_VIDEO] (state, { parish, video, vote }) {
    if (vote && vote.deleted) {
      state.videos[parish.id][video.id].votes.count--
      state.videos[parish.id][video.id].votes.self = false
    } else {
      state.videos[parish.id][video.id].votes.count++
      state.videos[parish.id][video.id].votes.self = true
    }
  },

  [BLOG_LIB_CATALOG_OPEN] (state, { parish, catalog }) {
    Vue.set(state.catalogs[parish.id][catalog.id], 'opened', true)
  },
  [BLOG_LIB_CATALOG_CLOSE] (state, { parish, catalog }) {
    Vue.set(state.catalogs[parish.id][catalog.id], 'opened', false)
    closeChildren(catalog, state.catalogs[parish.id])
  }
}

const closeChildren = (catalog, catalogs) => {
  const children = Object.values(catalogs).filter(child => {
    return catalog.id === child.parent
  })

  children.forEach(child => {
    Vue.set(catalogs[child.id], 'opened', false)
    closeChildren(child, catalogs)
  })
}
